// extracted by mini-css-extract-plugin
export default {"title":"waa-z","warning":"xaa-z","sizeOptionsLegendText":"yaa-z"};